(function () {
  'use strict';

  var resizeTimer = null;

  function prefersReducedMotion() {
    return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function ensureEnoughSlides(wrapper, minSlides) {
    wrapper.querySelectorAll('.swiper-slide[data-cc-loop-clone="true"]').forEach(function (el) {
      el.remove();
    });

    var originals = Array.prototype.slice.call(
      wrapper.querySelectorAll('.swiper-slide:not([data-cc-loop-clone="true"])')
    );
    if (!originals.length) return 0;

    while (wrapper.querySelectorAll('.swiper-slide').length < minSlides) {
      originals.forEach(function (source) {
        if (wrapper.querySelectorAll('.swiper-slide').length >= minSlides) return;
        var clone = source.cloneNode(true);
        clone.setAttribute('data-cc-loop-clone', 'true');
        clone.removeAttribute('data-swiper-slide-index');
        clone.querySelectorAll('[id]').forEach(function (node) {
          node.removeAttribute('id');
        });
        wrapper.appendChild(clone);
      });
    }

    return wrapper.querySelectorAll('.swiper-slide').length;
  }

  function syncToggleLabel(wrap, button, expanded) {
    var moreLabel = button.getAttribute('data-label-more') || 'Read more';
    var lessLabel = button.getAttribute('data-label-less') || 'Read less';
    button.textContent = expanded ? lessLabel : moreLabel;
    button.setAttribute('aria-expanded', expanded ? 'true' : 'false');
  }

  function resetTextToggles(root) {
    var scope = root || document;
    scope.querySelectorAll('[data-cc-text-toggle]').forEach(function (wrap) {
      var button = wrap.querySelector('.cc-testimonials__text-toggle');
      if (!button) return;
      wrap.setAttribute('data-expanded', 'false');
      syncToggleLabel(wrap, button, false);
    });
  }

  function updateTextToggle(wrap) {
    var body = wrap.querySelector('.cc-testimonials__text-body');
    var button = wrap.querySelector('.cc-testimonials__text-toggle');
    if (!body || !button) return;

    var wasExpanded = wrap.getAttribute('data-expanded') === 'true';

    wrap.setAttribute('data-expanded', 'false');
    // Force layout so scrollHeight reflects the clamped state
    void body.offsetHeight;

    var overflows = body.scrollHeight > body.clientHeight + 1;

    if (!overflows) {
      wrap.setAttribute('data-expanded', 'false');
      button.hidden = true;
      syncToggleLabel(wrap, button, false);
      return;
    }

    button.hidden = false;
    wrap.setAttribute('data-expanded', wasExpanded ? 'true' : 'false');
    syncToggleLabel(wrap, button, wasExpanded);
  }

  function initTextToggles(root) {
    var scope = root || document;
    scope.querySelectorAll('[data-cc-text-toggle]').forEach(updateTextToggle);
  }

  function refreshSwiperHeight(wrap) {
    var swiperEl = wrap.closest('.cc-testimonials-swiper');
    if (swiperEl && swiperEl.swiper && typeof swiperEl.swiper.update === 'function') {
      swiperEl.swiper.update();
    }
  }

  function getHeaderOffset() {
    var stickyHeader = document.querySelector('sticky-header');
    if (stickyHeader) {
      return stickyHeader.offsetHeight || 0;
    }
    var headerHeight = getComputedStyle(document.documentElement).getPropertyValue('--header-height');
    var parsed = parseFloat(headerHeight);
    return Number.isFinite(parsed) ? parsed : 0;
  }

  // If the section top is scrolled out of view by more than 500px, bring it back to the top
  function maybeScrollSectionToTop(sectionEl) {
    if (!sectionEl) return;

    var headerOffset = getHeaderOffset();
    var rect = sectionEl.getBoundingClientRect();
    var hiddenFromTop = headerOffset - rect.top;
    console.log('hiddenFromTop', hiddenFromTop);

    if (hiddenFromTop <= 400) return;

    var targetTop = window.scrollY + rect.top - headerOffset;
    window.scrollTo({
      top: Math.max(0, targetTop),
      behavior: prefersReducedMotion() ? 'auto' : 'smooth'
    });
  }

  function initTestimonialsSlider(sectionEl) {
    if (!sectionEl || typeof window.Swiper === 'undefined') return;

    var swiperEl = sectionEl.querySelector('.cc-testimonials-swiper');
    if (!swiperEl) return;

    var wrapper = swiperEl.querySelector('.swiper-wrapper');
    if (!wrapper) return;

    if (swiperEl.swiper) {
      swiperEl.swiper.destroy(true, true);
    }

    var originalCount = wrapper.querySelectorAll(
      '.swiper-slide:not([data-cc-loop-clone="true"])'
    ).length;
    if (originalCount < 1) return;

    // Need enough slides for slidesPerView: 3 + loop
    if (originalCount >= 2) {
      ensureEnoughSlides(wrapper, 6);
    }

    var prevButton = sectionEl.querySelector('.cc-testimonials__nav-btn--prev');
    var nextButton = sectionEl.querySelector('.cc-testimonials__nav-btn--next');
    var reducedMotion = prefersReducedMotion();

    new window.Swiper(swiperEl, {
      slidesPerView: 1,
      spaceBetween: 0,
      centeredSlides: true,
      loop: true,
      watchOverflow: false,
      speed: reducedMotion ? 0 : 400,
      grabCursor: true,
      navigation:
        prevButton && nextButton
          ? {
              nextEl: nextButton,
              prevEl: prevButton
            }
          : false,
      a11y: {
        enabled: true,
        prevSlideMessage: 'Previous testimonial',
        nextSlideMessage: 'Next testimonial'
      },
      keyboard: {
        enabled: true,
        onlyInViewport: true
      },
      breakpoints: {
        750: {
          slidesPerView: 1,
          spaceBetween: 24,
          centeredSlides: true
        },
        990: {
          slidesPerView: 1.87,
          spaceBetween: 30,
          centeredSlides: true
        }
      },
      on: {
        init: function () {
          initTextToggles(sectionEl);
        },
        resize: function () {
          initTextToggles(sectionEl);
        },
        slideChangeTransitionStart: function () {
          resetTextToggles(sectionEl);
          this.update();
          maybeScrollSectionToTop(sectionEl);
        }
      }
    });

    initTextToggles(sectionEl);
  }

  function whenSwiperReady(cb) {
    if (typeof window.Swiper !== 'undefined') {
      cb();
      return;
    }
    var tries = 0;
    var timer = setInterval(function () {
      tries += 1;
      if (typeof window.Swiper !== 'undefined') {
        clearInterval(timer);
        cb();
      } else if (tries > 50) {
        clearInterval(timer);
      }
    }, 100);
  }

  function initAll() {
    whenSwiperReady(function () {
      document.querySelectorAll('[data-cc-testimonials]').forEach(function (sectionEl) {
        initTestimonialsSlider(sectionEl);
      });
    });
  }

  document.addEventListener('click', function (event) {
    var button = event.target.closest('.cc-testimonials__text-toggle');
    if (!button) return;

    var wrap = button.closest('[data-cc-text-toggle]');
    if (!wrap) return;

    event.preventDefault();
    var expanded = wrap.getAttribute('data-expanded') === 'true';
    wrap.setAttribute('data-expanded', expanded ? 'false' : 'true');
    syncToggleLabel(wrap, button, !expanded);
    refreshSwiperHeight(wrap);
  });

  window.addEventListener('resize', function () {
    window.clearTimeout(resizeTimer);
    resizeTimer = window.setTimeout(function () {
      initTextToggles(document);
    }, 150);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var container = event.detail && event.detail.container ? event.detail.container : event.target;
    var section = container.querySelector
      ? container.querySelector('[data-cc-testimonials]')
      : null;
    if (!section && container && container.hasAttribute && container.hasAttribute('data-cc-testimonials')) {
      section = container;
    }
    if (section) {
      whenSwiperReady(function () {
        initTestimonialsSlider(section);
      });
    }
  });

  document.addEventListener('shopify:section:reorder', initAll);
})();
